var _path, _g, _line, _line2, _g2, _g3, _g4, _path2, _line3, _line4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupCity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a24772de-dc62-4664-b2bd-4e9ba6367903",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.5 77.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.3,40.8a6.45,6.45,0,0,0-5.5-9.9,6.71,6.71,0,0,0-2.8.6,9,9,0,0,0-7.2-5.9h-.1a4.87,4.87,0,0,0-1.2-.1h0a4.87,4.87,0,0,0-1.2.1h-.1A9.12,9.12,0,0,0,72,31.5a6.39,6.39,0,0,0-2.8-.6,6.49,6.49,0,0,0-6.5,6.5,5.89,5.89,0,0,0,1,3.4,6.48,6.48,0,0,0-3.4,5.7A6.58,6.58,0,0,0,66,53h.2v.1l-.1-.1a9.06,9.06,0,0,0,7.6,7.1,8.6,8.6,0,0,0,5.7-1.2l2.2-.1a9.74,9.74,0,0,0,5.9,1.3A8.93,8.93,0,0,0,95.1,53l-.4.1.1-.1H95a6.5,6.5,0,0,0,5.7-6.5A6.41,6.41,0,0,0,97.3,40.8Z",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.2,21.1A4.93,4.93,0,0,1,21.3,19h.2a6.84,6.84,0,0,1,5.9-3.3A7,7,0,0,1,34,20.4a3.49,3.49,0,0,1,3.3,3.4H19.4",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,27.3a4.08,4.08,0,0,1,4.1-3.9h.2a5.5,5.5,0,0,1,9.9,1.2,2.61,2.61,0,0,1,2.6,2.7H5.5Z",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 66.8,
    y1: 15.3,
    x2: 62.5,
    y2: 15.3,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 74.1,
    y1: 19,
    x2: 65.5,
    y2: 19,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.9,50.2a17.67,17.67,0,0,1-5.5,2.7,10.78,10.78,0,0,1,.5-4.9c1.8-4.9,7-6.2,7-6.2a22.91,22.91,0,0,0-.7,3.6C23.1,47.1,23.4,48.8,21.9,50.2Z",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,48.3s-6,6.8-7.2,11.1",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7,50.2a17.67,17.67,0,0,0,5.5,2.7A10.8,10.8,0,0,0,8.7,48c-1.8-4.9-7-6.2-7-6.2a22.91,22.91,0,0,1,.7,3.6C2.6,47.1,2.2,48.8,3.7,50.2Z",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,48.3s6,6.8,7.2,11.1",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.9,63.6a17.67,17.67,0,0,1-5.5,2.7,10.8,10.8,0,0,1,.5-4.9c1.8-4.9,7-6.2,7-6.2a22.91,22.91,0,0,0-.7,3.6C23.1,60.5,23.4,62.3,21.9,63.6Z",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,61.7s-6,6.8-7.2,11.1",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7,63.6a17.67,17.67,0,0,0,5.5,2.7,10.8,10.8,0,0,0-.5-4.9c-1.8-4.9-7-6.2-7-6.2a22.91,22.91,0,0,1,.7,3.6C2.6,60.5,2.2,62.3,3.7,63.6Z",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,61.7s6,6.8,7.2,11.1",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.8,
    y: 34.1,
    width: 21.5,
    height: 41.5,
    strokeWidth: 2,
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 20.5,
    width: 12.4,
    height: 13.6,
    strokeWidth: 2,
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.5 6.3 42.3 20.5 48.5 20.5 54.8 20.5 48.5 6.3",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8,
    y: 41.3,
    width: 9,
    height: 34.3,
    strokeWidth: 2,
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.3,
    y: 41.3,
    width: 9,
    height: 34.3,
    strokeWidth: 2,
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.9,
    y: 37.9,
    width: 3.5,
    height: 6.7,
    strokeWidth: 2,
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.8,
    y: 37.9,
    width: 3.5,
    height: 6.7,
    strokeWidth: 2,
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.8,
    y: 24,
    width: 3.5,
    height: 6.7,
    strokeWidth: 2,
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7,
    y: 37.9,
    width: 3.5,
    height: 6.7,
    strokeWidth: 2,
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 40.9,
    y1: 50.9,
    x2: 40.9,
    y2: 47,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 50.9,
    x2: 44,
    y2: 47,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 50.9,
    x2: 47,
    y2: 47,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.1,
    y1: 50.9,
    x2: 50.1,
    y2: 47,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.1,
    y1: 50.9,
    x2: 53.1,
    y2: 47,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.1,
    y1: 47,
    x2: 56.1,
    y2: 50.9,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 40.9,
    y1: 57.5,
    x2: 40.9,
    y2: 53.6,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 57.5,
    x2: 44,
    y2: 53.6,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 57.5,
    x2: 47,
    y2: 53.6,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.1,
    y1: 57.5,
    x2: 50.1,
    y2: 53.6,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.1,
    y1: 57.5,
    x2: 53.1,
    y2: 53.6,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.1,
    y1: 53.6,
    x2: 56.1,
    y2: 57.5,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 31.8,
    y1: 49.4,
    x2: 31.8,
    y2: 45.4,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.8,
    y1: 49.4,
    x2: 34.8,
    y2: 45.4,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 31.8,
    y1: 56.5,
    x2: 31.8,
    y2: 52.5,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.8,
    y1: 56.5,
    x2: 34.8,
    y2: 52.5,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 62.3,
    y1: 49.4,
    x2: 62.3,
    y2: 45.4,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.3,
    y1: 49.4,
    x2: 65.3,
    y2: 45.4,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 62.3,
    y1: 56.5,
    x2: 62.3,
    y2: 52.5,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.3,
    y1: 56.5,
    x2: 65.3,
    y2: 52.5,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 48.5,
    y1: 1.8,
    x2: 48.5,
    y2: 6.3,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.7,
    y1: 20.5,
    x2: 48.6,
    y2: 6.5,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.4,
    y1: 20.5,
    x2: 48.5,
    y2: 6.5,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.4 64.6 45 64.6 45 75.6 47 75.6 50.4 75.6 52.4 75.6 52.4 64.6",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4,41.5a5.81,5.81,0,0,1-3.5,5.2,5.81,5.81,0,0,1-3.5-5.2c0-3.8,3.5-8.6,3.5-8.6S16.4,37.7,16.4,41.5Z",
    fill: "#fff",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12.8,
    y1: 41.1,
    x2: 12.8,
    y2: 76.3,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 80.4,
    y1: 34.5,
    x2: 80.4,
    y2: 75.6,
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "71.8 45.3 80.4 53.9 91.1 43.2",
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "75.5 41.2 80.4 46.1 86.3 40.2",
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "77.8 36.4 80.4 39 83 36.4",
    fill: "none",
    stroke: "#ffa599",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupCity);
export default __webpack_public_path__ + "static/media/signup-city.65300ab805c3b33c23d2b11285fbfcb3.svg";
export { ForwardRef as ReactComponent };